import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Check2Square, Key, SendCheck, Square } from 'react-bootstrap-icons'
import DateTimePickerFunctions from '../../../../components/ui/calendar/date_picket/DateTimePickerComponents/DateTimePickerFunctions'
import Authentication from '../../../../libs/api/services/Authentication'
import Share from '../../../../libs/api/services/Share'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
import AccessModal, { AccessList } from './AccessModal'
import PatientContext from './PatientProvider'

export default function PatientProfileShare() {
    const { activePatient } = useContext(PatientContext)
    const { createModal, showError } = useContext(CommonFunctionsContext)
    const [requests, setRequests] = useState()
    const [shared, setShared] = useState()
    const [loading, setLoading] = useState(true)
    // alert(JSON.stringify(activePatient.userProfile.id))
    useEffect(() => {
        const load = async () => {
            setRequests(await Share.ListShareRequests().catch(showError))
            setShared(await Share.ListShareRequestsShared().catch(showError))
            setLoading(false)
        }
        load()
    }, [])

    const SelectableLineItem = ({ Detail, onClicked }) => {
        const [selected, setSelected] = useState()
        const handleClicked = (event) => {
            if (onClicked) {
                event.preventDefault()
                event.stopPropagation()
                onClicked()
            }
        }

        return <div
            onClick={() => setSelected(!selected)}
            className='d-flex mx-2 cursor-pointer'>
            <div onClick={handleClicked} className='flex-grow-1'>{Detail}</div>
            <div>{selected ? <Check2Square /> : <Square />}</div>
        </div>
    }
    const handleShareAccess = () => createModal(<AccessShareModalEmail whosInformation={activePatient.userProfile} />, 'Access', <Key />)
    const handleShowAccess = () => createModal(<AccessModal whosInformation={activePatient.userProfile} />, 'Access', <Key />)
    return (loading ?
        <div className='d-flex flex-grow-1 flex-column align-items-center justify-content-center'>
            <FontAwesomeIcon icon={faSpinner} size={'4x'} spin />
            <b className='p-3'>Loading information share requests</b>
        </div> :
        <div className='d-flex flex-column flex-xl-row flex-grow-1 m-2'>
            <div className='flex-grow-1 d-flex flex-column 2-50'>
                <div className='flex-grow-1'>
                    <h2 className='text-center flex-grow-1 m-2'>Pending Requests</h2>
                    {requests && requests.map(request =>
                        <div
                            className='shadow p-2 text-center bg-secondary-container m-2'
                            style={{ cursor: 'pointer' }}
                            onClick={() => createModal(<AccessShareModalRequests request={request} />, `Information request ${DateTimePickerFunctions.LocalISO(new Date(request.created))} `)}
                            key={request.id}>{`Request On ${DateTimePickerFunctions.LocalISO(new Date(request.created), 'h')} for information regarding ${request.shareFor && request.shareFor.firstName} ${request.shareFor && request.shareFor.lastName}`} {request.status}</div>
                    )}
                </div>
                <div className='text-center m-2'>
                    <button
                        onClick={() => handleShowAccess()}
                        className='btn bg-primary-container'>Request Additional Information</button>
                    <button onClick={handleShareAccess} className='btn bg-primary-container mx-2'>Share a link</button>
                </div>
            </div >
            {/* <div className='flex-grow-1 d-flex flex-column '>
                <div className='flex-grow-1'>
                    <h2 className='text-center m-2'>Share additional information</h2>
                     {shared && shared.map(request =>
                        <div
                            className='shadow p-2 text-center bg-secondary-container m-2'
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                                createModal(<AccessShareModalRequests request={request} />,
                                    `Information request ${DateTimePickerFunctions.LocalISO(new Date(request.requestedOn))} ${request.isApproved ? '- Approved' : '- Pending'}`)}
                            key={request.id}>
                            {`Request On ${DateTimePickerFunctions.LocalISO(new Date(request.requestedOn), 'h')} to share information with ${request.shareWith.emailAddress} regarding ${request.whosInformation && request.whosInformation.firstName} ${request.whosInformation && request.whosInformation.lastName}`}
                        </div>
                    )} 
                </div>
                <div className='text-center m-2'>
                    <button onClick={handleShareAccess} className='btn bg-primary-container mx-2'>Share a link</button>
                    <button className='btn bg-primary-container mx-2'>Approve</button>
                </div>
            </div> */}
        </div >
    )
}

const AccessShareModalRequests = ({ close, request }) => {
    const [allocatedResources, setAllocatedResources] = useState(request.rule.accessRuleResources &&
        request.rule.accessRuleResources.map(res => {
            return {
                resource: res.resource,
                accessType: res.accessType
            }
        }))
    return (<AccessList disabled allocatedResources={allocatedResources} setAllocatedResources={setAllocatedResources} />)
}
const AccessShareModalEmail = ({ close, whosInformation }) => {
    const { showError, showToast } = useContext(CommonFunctionsContext)
    const [allocatedResources, setAllocatedResources] = useState([])
    const EmailRef = useRef()
    const NameRef = useRef()
    const LNameRef = useRef()
    const handleSave = async () => {
        showToast("Processing Request", <SendCheck />, 7)
        Share.CreateShareRequest({
            requestedBy: { id: Authentication.UserId() },
            whosInformation: whosInformation,
            shareWith: {
                firstName: NameRef.current.value,
                lastName: LNameRef.current.value,
                emailAddress: EmailRef.current.value
            },
            RequestedOn: new Date(),
            resources: allocatedResources.map(res => {
                return {
                    resource: {
                        resource: res.resource,
                        accessType: res.accessType
                    },
                    isApproved: false,
                }
            })
        }).then(res => close(() => { showToast("Your request has been sent", <SendCheck />, 7) }))
            .catch(e => close(() => { showError(e) }))
    }
    return (<form
        onSubmit={e => {
            e.preventDefault()
            handleSave()
        }}
        className='flex-grow-1 d-flex flex-column'>
        <div className='p-3'>
            <label>Please enter the details of the person you would like to share the information with</label>
            <div className='d-flex'>
                <div className='w-50 pe-1'>
                    <label>First Name</label>
                    <input type='firstName' required ref={NameRef} className='form-control' placeholder='First Name' />
                </div>
                <div className='w-50 ps-1'>
                    <label>Last Names</label>
                    <input type='lastName' required ref={LNameRef} className='form-control' placeholder='Last Names' />
                </div>
            </div>
            <div>
                <label>Email</label>
                <input type='email' required ref={EmailRef} className='form-control' placeholder='Email' />
            </div>
        </div>
        <div className='flex-grow-1 px-3'>
            <AccessList allocatedResources={allocatedResources} setAllocatedResources={setAllocatedResources} />
        </div>
        <div className='text-center m-3'>
            <button type='submit'
                // onClick={handleSave} 
                className='btn bg-secondary-container'>Send</button>
        </div>
    </form>)
}